import { AlertTriangle } from 'react-feather';
import styled from 'styled-components';

export const Warning = styled(AlertTriangle)`
	color: #e38f4d;
	flex-shrink: 0;
	height: 1rem;
	vertical-align: text-bottom;
	width: 1.75rem;
`;
